module.exports = __webpack_public_path__ + "aee47b9aaa038bf1e83644599dd85bf0.svg";